import PantallaIndice from './pantalla-indice'
export default PantallaIndice